<template>
  <v-card class="section-container">
      <div
      v-for="(service, index) in services"
      :expand-icon="configuration.multiplePeopleEnabled || checkServicePrice ? 'keyboard_arrow_down' : ''"
      v-bind:class="bgColorClass[index] || selectedColorClass[index]"
      :key="index">
        <v-checkbox
          v-model="copyCheckedServices"
          class="service-chkbox"
          :ripple="true"
          :id="service.publicId"
          :value="service.publicId"
          :readonly="readOnlyCheckBoxes"
          :disabled="!service.isInAppointmentProfile"
          hide-details="true"
          :aria-label="getServiceName(service)"
          @change="updateParent"
          aria-required="true"
        >
          <template v-slot:label>
            {{getServiceName(service)}}
              <v-btn text icon @click="showInfo($event, index)" @click.stop="" ref="showInfoRef" class="showInfo" v-if="serviceTemplates !== undefined && serviceTemplates[service.qpId] !== undefined && serviceTemplates[service.qpId][selectedLanguage.lang]"
                :aria-label="showInfoText[index]">
                <v-icon aria-hidden="false">info</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="configuration.multiplePeopleEnabled  && (!configuration.multiplePeopleHideNoDuration || configuration.multiplePeopleHideNoDuration && service.additionalDuration > 0)" @click.stop="switchPanel(index)" icon tabindex="-1">
                <v-icon>{{ servicePanel[index] | chevron }}</v-icon>
              </v-btn>
          </template>
        </v-checkbox>
        <v-card v-if="servicePanel[index] && configuration.multiplePeopleEnabled && service.isInAppointmentProfile && (!configuration.multiplePeopleHideNoDuration || configuration.multiplePeopleHideNoDuration && service.additionalDuration > 0)">
          <v-card-text class="flex">
            <v-row>
              <v-col cols="6" sm="3" class="ma-0" v-if="maxAdultsAllowed">
                <div class="choose-wrapper adult">
                  <small>{{messages.chooseServiceContentAdults}}</small>
                  <div class="amount-of">
                    <v-btn
                      class="input-btn"
                      :ripple="false"
                      text
                      :aria-label="messages.ariaRemoveOneAdult"
                      @click="removeCustomer('adult', service.publicId)"
                      :id="'adultRemoveButton-' + service.publicId"
                    >
                      <v-icon>remove</v-icon>
                    </v-btn>
                    <div class="number" aria-hidden="true">{{getAdults(service.publicId)}}</div>
                    <v-btn
                      :disabled="getMaxPeopleReached(service.publicId)|| getMaxAdultsReached(service.publicId) || getMaxPeopleBookingReached()"
                      text
                      :ripple="false"
                      :aria-label="messages.ariaAddOneAdult"
                      class="input-btn"
                      @click="addCustomer('adult', service.publicId)"
                      :id="'adultAddButton-' + service.publicId"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </div>
                  <small
                    v-if="checkShowPricesAndServicePrice"
                  >{{messages.chooseServiceContentPrice}}: {{service.custom.cost.adult.default}} {{messages.chooseServiceContentCurrency}}</small>
                </div>
              </v-col>
              <v-col cols="6" sm="4" class="ma-0" v-if="maxChildrenAllowed">
                <div class="choose-wrapper child">
                  <small>{{messages.chooseServiceContentChildren}} {{messages.chooseServiceChildrenAge}}</small>
                  <div class="amount-of">
                    <v-btn
                      :ripple="false"
                      text
                      class="input-btn"
                      :aria-label="messages.ariaRemoveOneChild"
                      @click="removeCustomer('child', service.publicId)"
                      :id="'childRemoveButton-' + service.publicId"
                    >
                      <v-icon>remove</v-icon>
                    </v-btn>
                    <div class="number" aria-hidden="true">{{getChildren(service.publicId)}}</div>
                    <v-btn
                      text
                      :ripple="false"
                      :disabled="getMaxPeopleReached(service.publicId)|| getMaxChildrenReached(service.publicId) || getMaxPeopleBookingReached()"
                      :aria-label="messages.ariaAddOneChild"
                      class="input-btn"
                      @click="addCustomer('child', service.publicId)"
                      :id="'childAddButton-' + service.publicId"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </div>
                  <small
                    v-if="checkShowPricesAndServicePrice"
                  >{{messages.chooseServiceContentPrice}}: {{service.custom.cost.child.default}} {{messages.chooseServiceContentCurrency}}</small>
                </div>
              </v-col>
              <v-col cols="12" sm="5" class="ma-0">
                <small
                  v-if="checkShowPricesAndServicePrice"
                  aria-hidden="true"
                  class="service-total-cost"
                >{{getTotalCost(service.publicId)}}</small>
                <v-alert v-if="getMaxReached(service.publicId) || getMaxPeopleBookingReached()"
                :aria-hidden="!getMaxReached(service.publicId) && !getMaxPeopleBookingReached()"
                role="alert"
                :value="getMaxReached(service.publicId) || getMaxPeopleBookingReached()"
                type="info">
                {{maxInfoMessage[service.publicId]}}</v-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <modal-dialog
            :dialog="dialog"
            :dialogMessage="dialogMessage"
            :dialogTitle="dialogTitle"
            :dialogButtonText="dialogButtonText"
            @closemodal="hideInfoDialog">
      </modal-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormatService from '../services/formatService'
import DataService from '../services/dataService'
import ModalDialog from '../components/Modal'

export default {
  name: 'ServiceCardCheckBox',
  mixins: [FormatService, DataService],
  props: [
    'services',
    'readOnlyCheckBoxes',
    'maxBookingPeopleAllowed',
    'maxPeopleAllowed',
    'maxAdultsAllowed',
    'maxChildrenAllowed',
    'checkedServices'
  ],
  data: () => ({
    maxPeopleBookingReached: false,
    maxPeopleReached: [],
    maxAdultsReached: [],
    maxChildrenReached: [],
    adults: [],
    children: [],
    copyCheckedServices: [],
    totalCosts: [],
    maxInfoMessage: [],
    dialog: false,
    dialogMessage: '',
    dialogTitle: '',
    dialogButtonText: '',
    bgColorClass: [],
    selectedColorClass: [],
    servicePanel: [],
    showInfoText: [],
    initPreselect: false
  }),
  components: {
    ModalDialog
  },
  computed: {
    ...mapState([
      'funcDebug',
      'configuration',
      'messages',
      'selectedLanguage',
      'serviceTemplates'
    ]),
    ...mapGetters([
      'isServicesPreselected'
    ]),
    getAdults: function () {
      return (publicId) => this.adults !== undefined ? (this.adults[publicId] !== undefined ? this.adults[publicId] : 0) : 0
    },

    getChildren: function () {
      return (publicId) => this.children !== undefined ? (this.children[publicId] !== undefined ? this.children[publicId] : 0) : 0
    },
    getMaxReached: function () {
      return (publicId) => this.maxPeopleReached[publicId] || this.maxAdultsReached[publicId] || (this.maxChildrenAllowed > 0 ? this.maxChildrenReached[publicId] : 0)
    },
    getMaxPeopleBookingReached: function () {
      return () => this.maxPeopleBookingReached !== undefined ? this.maxPeopleBookingReached : 0
    },
    getMaxPeopleReached: function () {
      return (publicId) => this.maxPeopleReached !== undefined ? this.maxPeopleReached[publicId] : 0
    },
    getMaxAdultsReached: function () {
      return (publicId) => this.maxAdultsReached !== undefined ? this.maxAdultsReached[publicId] : 1
    },
    getMaxChildrenReached: function () {
      return (publicId) => this.maxChildrenReached !== undefined && this.maxChildrenAllowed > 0 ? this.maxChildrenReached[publicId] : 1
    },
    getTotalCost: function () {
      return (publicId) => this.messages.totalCost + ': ' + (typeof this.totalCosts[publicId] === 'undefined' ? 0 : this.totalCosts[publicId]) + ' ' + this.messages.chooseServiceContentCurrency
    },

    checkShowPricesAndServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'servicesPrice'
    },
    checkServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.priceCalc === 'servicesPrice'
    }
  },
  filters: {
    chevron: function (value) {
      return value ? 'mdi-chevron-up' : 'mdi-chevron-down'
    }
  },
  watch: {
    copyCheckedServices (newValue, oldValue) {
      if (this.funcDebug) console.log('ServiceCardCheckBox:watch:copyCheckedServices')
      // the first time this is executed newValue = oldValue but we need to open the some servicePanel in some cases
      if (this.initPreselect) {
        // open first panel only if multiplePeopleEnabled option is true
        if (newValue.length > 0 && this.configuration.multiplePeopleEnabled) {
          let itempos = this.services.findIndex((elem) => {
            return elem.publicId === newValue[0]
          })
          this.servicePanel[itempos] = true
        }
        this.initPreselect = false
      } else {
        let removed = oldValue.filter((val) => {
          return newValue.indexOf(val) === -1
        })
        let added = newValue.filter((val) => {
          return oldValue.indexOf(val) === -1
        })
        if (added.length > 0) {
          for (let i = 0; i < added.length; i++) {
            let itempos = this.services.findIndex((elem) => {
              return elem.publicId === added[i]
            })
            this.servicePanel[itempos] = true
          }
        }
        if (removed.length > 0) {
          for (let i = 0; i < removed.length; i++) {
            let itempos = this.services.findIndex((elem) => {
              return elem.publicId === removed[i]
            })
            this.servicePanel[itempos] = false
          }
        }
        if ((removed.length > 0) || (added.length > 0)) {
          this.servicePanel = [...this.servicePanel]
        }
      }
    },
    checkedServices: {
      handler (newValue, oldValue) {
        if (this.funcDebug) console.log('ServiceCardCheckBox:watch:checkedServices')
        // All the following variables are recreated to force this component to re-read the
        // values of adults, children, totalcost etc. if the service is updated in another service group
        this.copyCheckedServices = []
        this.adults = []
        this.children = []
        this.maxPeopleBookingReached = false
        this.maxPeopleReached = []
        this.maxChildrenReached = []
        this.maxAdultsReached = []
        this.totalCosts = []
        let countTotalPeople = 0

        for (var i = 0; i < this.checkedServices.length; i++) {
          this.copyCheckedServices[i] = this.checkedServices[i].publicId
        }
        for (var j = 0; j < this.services.length; j++) {
          var checkedServiceIndex = this.getByValue(this.checkedServices, this.services[j].publicId)
          countTotalPeople += this.services[j].adult + this.services[j].child
          if (checkedServiceIndex !== undefined && checkedServiceIndex !== null) {
            this.adults[this.checkedServices[checkedServiceIndex].publicId] = this.checkedServices[checkedServiceIndex].adult
            this.children[this.checkedServices[checkedServiceIndex].publicId] = this.checkedServices[checkedServiceIndex].child
            this.maxPeopleReached[this.checkedServices[checkedServiceIndex].publicId] = ((this.checkedServices[checkedServiceIndex].adult + this.checkedServices[checkedServiceIndex].child) === this.maxPeopleAllowed)
            this.maxAdultsReached[this.checkedServices[checkedServiceIndex].publicId] = (this.checkedServices[checkedServiceIndex].adult === this.maxAdultsAllowed)
            this.maxChildrenReached[this.checkedServices[checkedServiceIndex].publicId] = (this.checkedServices[checkedServiceIndex].child === this.maxChildrenAllowed)
            this.totalCosts[this.checkedServices[checkedServiceIndex].publicId] = this.checkedServices[checkedServiceIndex].totalCost
            this.maxPeopleBookingReached = (countTotalPeople >= this.maxBookingPeopleAllowed)
            this.setMaxInfoText(this.checkedServices[checkedServiceIndex].publicId)
            this.bgColorClass[j] = 'selected'
            this.selectedColorClass[j] = 'selectedColor'
          } else {
            this.adults[this.services[j].publicId] = 0
            this.children[this.services[j].publicId] = 0
            this.maxPeopleReached[this.services[j].publicId] = false
            this.maxAdultsReached[this.services[j].publicId] = false
            this.maxChildrenReached[this.services[j].publicId] = false
            this.totalCosts[this.services[j].publicId] = 0
            this.maxPeopleBookingReached = (countTotalPeople >= this.maxBookingPeopleAllowed)
            this.setMaxInfoText(this.services[j].publicId)
            this.bgColorClass[j] = ''
            this.selectedColorClass[j] = 'deselectedColor'
          }
        }
      },
      deep: true
    },
    selectedLanguage: {
      handler (newValue, oldValue) {
        this.setAriaInfoTxt()
      }
    }
  },
  methods: {
    ...mapActions([
      'addSelectedService',
      'setSelectedServices',
      'resetSelectedServices',
      'checkServicesValidity'
    ]),
    // switch panel opening state
    switchPanel (index) {
      if (this.funcDebug) console.log('ServiceCardCheckBox:methods:switchPanel')
      this.servicePanel[index] = !this.servicePanel[index]
      this.servicePanel = [...this.servicePanel]
    },
    updateParent (value) {
      if (this.funcDebug) console.log('ServiceCardCheckbox:methods:updateParent')
      var updateCheckedServices = []
      for (var i = 0; i < this.copyCheckedServices.length; i++) {
        var checkedServiceIndex = this.getByValue(this.checkedServices, this.copyCheckedServices[i])
        if (typeof (checkedServiceIndex) !== 'undefined' && checkedServiceIndex !== null && value) {
          updateCheckedServices.push(this.checkedServices[checkedServiceIndex])
        } else {
          for (var j = 0; j < this.services.length; j++) {
            var thisService = this.services[j]
            if (thisService.publicId === this.copyCheckedServices[i]) {
              // conditional additional duration is also used to check if service has duration (for Hide people restrictions)
              if (this.configuration.multiplePeopleEnabled && (!this.configuration.multiplePeopleHideNoDuration || (this.configuration.multiplePeopleHideNoDuration && this.services[j].additionalDuration > 0))) {
                thisService.adult = 0
                thisService.child = 0
                thisService.totalCost = 0
                thisService.totalPeople = 0
                thisService.customLength = 0
              } else {
                thisService.adult = 1
                thisService.child = 0
                if (thisService.custom.cost && this.checkServicePrice) { thisService.totalCost = thisService.custom.cost['adult'].default } else { thisService.totalCost = 0 }
                thisService.totalPeople = 1
                thisService.customLength = thisService.duration
              }
              updateCheckedServices.push(thisService)
            }
          }
        }
      }
      this.$emit('update-checked-services', updateCheckedServices)
    },
    addCustomer (typeOfPeople, serviceId) {
      if (this.funcDebug) console.log('ServiceCardCheckBox:methods:addCustomer')
      var toAddService = {}
      var checkedServiceIndex = this.getByValue(this.checkedServices, serviceId)
      if (typeof (checkedServiceIndex) !== 'undefined' && checkedServiceIndex !== null) {
        toAddService = this.checkedServices[checkedServiceIndex]
      } else {
        for (var j = 0; j < this.services.length; j++) {
          if (this.services[j].publicId === serviceId) {
            toAddService = this.services[j]
            toAddService.adult = 0
            toAddService.child = 0
            toAddService.totalPeople = 0
            this.checkedServices.push(toAddService)
          }
        }
      }

      toAddService[typeOfPeople]++
      if (this.checkServicePrice) {
        toAddService.totalCost += toAddService.custom.cost[typeOfPeople].default
      }
      if (toAddService.totalPeople === 0) {
        toAddService.customLength = toAddService.duration
      } else {
        toAddService.customLength += toAddService.additionalDuration
      }
      toAddService.totalPeople++
      toAddService.maxPeopleReached = (toAddService.totalPeople === this.maxPeopleAllowed)
      toAddService.maxChildrenReached = (toAddService.child === this.maxChildrenAllowed)
      toAddService.maxAdultsReached = (toAddService.adult === this.maxAdultsAllowed)

      this.displaySelectedServiceInfo = true
      // Send the updated service to the checked services of the parent
      this.$emit('update-checked-services', this.checkedServices)
    },
    removeCustomer (typeOfPeople, serviceId) {
      if (this.funcDebug) console.log('ServiceCardCheckbox:methods:removeCustomer')
      var toAddService = {}

      var checkedServiceIndex = this.getByValue(this.checkedServices, serviceId)
      if (typeof (checkedServiceIndex) !== 'undefined' && checkedServiceIndex !== null) {
        toAddService = this.checkedServices[checkedServiceIndex]
      }
      if (toAddService[typeOfPeople] > 0) {
        toAddService[typeOfPeople]--
        if (this.checkServicePrice) {
          toAddService.totalCost -= toAddService.custom.cost[typeOfPeople].default
        }
        if (toAddService.totalPeople > 1) {
          toAddService.customLength -= toAddService.additionalDuration
        } else {
          toAddService.customLength -= toAddService.duration
        }
        toAddService.totalPeople--
        toAddService.maxPeopleReached = false
        if (typeOfPeople === 'child') { toAddService.maxChildrenReached = false }
        if (typeOfPeople === 'adult') { toAddService.maxAdultsReached = false }
      }

      this.$emit('update-checked-services', this.checkedServices)
    },
    setMaxInfoText: function (publicId) {
      this.maxInfoMessage[publicId] = ''
      if (this.maxPeopleReached[publicId]) {
        this.maxInfoMessage[publicId] = this.messages.infoMessageNumberOfPeopleReached.replace('%1', this.maxPeopleAllowed)
      } else if (this.maxAdultsReached[publicId] && (this.maxChildrenAllowed && this.maxChildrenReached[publicId])) {
        this.maxInfoMessage[publicId] = this.messages.infoMessageNumberOfAdultsReached.replace('%1', this.maxAdultsAllowed) + ', ' + this.messages.infoMessageNumberOfChildrenReached.replace('%1', this.maxChildrenAllowed)
      } else if (this.maxAdultsReached[publicId]) {
        this.maxInfoMessage[publicId] = this.messages.infoMessageNumberOfAdultsReached.replace('%1', this.maxAdultsAllowed)
      } else if (this.maxChildrenReached[publicId]) {
        this.maxInfoMessage[publicId] = this.messages.infoMessageNumberOfChildrenReached.replace('%1', this.maxChildrenAllowed)
      }
      if (this.maxPeopleBookingReached) {
        for (let key in this.maxInfoMessage) {
          if (!this.maxPeopleReached[key]) {
            this.maxInfoMessage[key] = this.messages.infoMessageNumberOfTotalPeopleReached ? this.messages.infoMessageNumberOfTotalPeopleReached.replaceAll('%1', this.maxBookingPeopleAllowed) : ''
          }
        }
      }
    },
    showInfo: function (v, index) {
      if (this.funcDebug) console.log('ServiceCardCheckbox:methods:showInfo')
      this.showModalDialog(this.services[index].qpId)
    },
    showModalDialog (serviceId) {
      if (this.funcDebug) console.log('ServiceCardCheckbox:methods:showModalDialog')
      this.dialogMessage = (this.serviceTemplates[serviceId])[this.selectedLanguage.lang]
      this.dialogTitle = this.messages.serviceTemplateHeader
      this.dialogButtonText = this.messages.dialog1ButtonText
      this.dialog = true
    },
    hideInfoDialog () {
      this.dialog = false
      this.$nextTick(() => {
        this.$refs.showInfoRef[0].$el.focus()
      })
    },
    setAriaInfoTxt () {
      if (this.services.length) {
        for (var x = 0; x < this.services.length; x++) {
          this.showInfoText[x] = this.messages.ariaShowInfo.replace('%1', this.getServiceName(this.services[x]))
        }
      }
    }
  },
  mounted () {
    if (this.funcDebug) console.log('ServiceCardCheckBox:mounted')
    if (this.isServicesPreselected) {
      this.initPreselect = true
    }
    for (var j = 0; j < this.services.length; j++) {
      this.adults[this.services[j].publicId] = this.services[j].adult
      this.children[this.services[j].publicId] = this.services[j].child
      this.totalCosts[this.services[j].publicId] = this.services[j].totalCost
    }
    for (var i = 0; i < this.checkedServices.length; i++) {
      this.copyCheckedServices.push(this.checkedServices[i].publicId)
    }
    this.setAriaInfoTxt()
  }
}

</script>
<style lang="scss" scoped>
.amount-of .v-btn {
  min-width: 50px;
  margin: 0;
  min-height: 50px;
  padding: 0;
}
.amount-of .v-btn.v-btn--text:focus {
  background-color: var(--defined-focused-element) !important;
}

.amount-of .number {
  min-width: 50px;
  border-top: 2px solid var(--primary-btn-bg-color) !important;
  border-bottom: 2px solid var(--primary-btn-bg-color) !important;
  line-height: 46px;
  font-weight: 500;
  text-align: center;
  font-size: 18px;
}

.radio-container {
  width: 100%;
}

.services-wrapper .v-expansion-panel.service-expansion-panel{
  flex: none;
  border: solid 1px var(--default-border-color) !important;
  background-color: var(--input-selection-bg-color);
  margin: 8px;
}

.services-wrapper .v-expansion-panel.service-expansion-panel .v-alert{
  margin: 0px 0px 25px 0px !important;
}

.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){
  margin-bottom: 0px
}

.services-wrapper.v-expansion-panel{
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 4px 8px !important;
}

.label-disabled{
  color:#E5E7E9 ;
}

.showInfo{
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin: 0 10px;
  color: var(--info-icon-color) !important;
  background-color: var(--info-icon-text-color) !important;
}
.showInfo :hover{
  color: var(--info-icon-color) !important;
}

.section-container > div {
  border: solid 1px var(--default-border-color) !important;
  background-color: var(--input-selection-bg-color);
  margin: 8px 0;
}

.deselectedColor{
  color:var(--primary-color) !important;
}

.v-input--selection-controls{
  padding: 12px 24px;
}

.selected {
  border: solid 1px var(--default-border-color) !important;
  .v-input--selection-controls{
    background-color: var(--focused-element)!important;
    border: none !important;
    color: #fff;
    min-height: 48px;
    border: none;
    margin-top: 0px;
    margin-bottom: 0px;
    .v-label{
      color: #fff !important;
    }
    .v-card{
      background-color: #fff !important;
    }
  }
  .info{
    margin:8px 0 22px 0 !important;
  }
}

.v-expansion-panel.service-expansion-panel .v-card{
  background-color: #fff !important;
}

.section-container{
  margin: 0px;
  .v-input{
    padding: 9px 24px !important;
  }
}
</style>
